import { call, put, takeEvery, select } from "redux-saga/effects";
import {
  getUserFailure,
  getUserSuccess
} from "../../actions/GetUser/getUserActions";
import { updateUserAction } from "../../actions/GetUser/updateUserActions";
import { editUserRequest } from "../../../api/requests/GetUser/editUserRequest";
import { message } from "antd";
import showSuccessWindow from "../../../../../common/components/successPopup/successPopup";
import { successAdminUpdation } from "../../../../SystemSettings/components/Licensee/success";

function* editUserSaga(action) {
  const { payload } = action;
  const userId = yield select(state => state.Authorization.user.id || 0);
  try {
    const response = yield call(editUserRequest, userId, payload);
    yield put(getUserSuccess(response));
    showSuccessWindow(successAdminUpdation());
  } catch (e) {
    message.error("Не удалось сохранить изменения");
    yield put(getUserFailure(e));
  }
}

export function* userWatcher() {
  yield takeEvery(updateUserAction.toString(), editUserSaga);
}
